/**
 * 后端数值字段的类型转换工具。
 *
 * <p>⚠️ 重要约定：后端 `JacksonConfig` 把 **所有 `Long` / `BigInteger` 字段序列化成 JSON 字符串**
 * （为了避免 Snowflake ID 超出 JS `Number.MAX_SAFE_INTEGER` 丢精度），
 * 前端 `api/*.js` 又用 `json-bigint({ storeAsString: true })` 解析，
 * 所以**后端返回的任何 `Long` 到了前端都是字符串**，例如点赞数 `"0"`、`"12"`。
 *
 * <p>直接对它做算术会变成字符串拼接：`"0" + 1 === "01"`（曾经真的让点赞角标显示成 `01`）。
 * 因此**凡是要拿后端 Long 参与运算或比较，必须先过一遍 {@link toNumber}**。
 *
 * @param {*} value 后端返回的值（字符串 / 数字 / null / undefined）
 * @param {number} fallback 无法转成有限数字时返回的兜底值
 * @returns {number} 安全的数字
 */
export function toNumber(value, fallback = 0) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : fallback
  }
  if (value === null || value === undefined || value === '') {
    return fallback
  }
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

export default toNumber
